import { Modal } from "flowbite-react";
import { useState } from "react";
import ReactMarkdown from "react-markdown";
import { bubbles_data } from "./data";

function BubbleItem(props: any) {
  const [openModal, setOpenModal] = useState<boolean>(false);
  return (
    <div
      className={`flex justify-center items-center text-center rounded-full w-[1000px] ${props.type} aspect-square`}
    >
      <div
        className="flex justify-center items-center w-full h-full rounded-full"
        onClick={() => {
          setOpenModal(true);
        }}
      >
        <span className="text-xl font-bold text-white">{props.title}</span>
      </div>

      <Modal
        dismissible
        show={openModal}
        onClose={() => {
          setOpenModal(false);
          console.log(openModal);
        }}
      >
        <Modal.Header>{props.title}</Modal.Header>
        <Modal.Body>
          <div className="space-y-6">
            <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
              <ReactMarkdown className="prose">{props.text}</ReactMarkdown>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  );
}

export default function BubblesProp(props: any) {
  // @ts-ignore
  let childrens = [];

  bubbles_data.forEach((elt: any, idx: number) => {
    childrens.push(<BubbleItem {...elt} />);
  });

  return <></>;
}
